"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Streem API
 * The Streem API gives you access to information captured during Streem calls.  You can retrieve artifacts such as recordings, streemshots (including captured model/serial numbers), and much more.
 *
 * The version of the OpenAPI document: 0.1.0
 * Contact: support@streem.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ListGroupAvailabilityStatus = exports.GroupsApi = void 0;
const runtime = __importStar(require("../runtime"));
const models_1 = require("../models");
/**
 *
 */
class GroupsApi extends runtime.BaseAPI {
    /**
     * Add a user to a group for a specific company.
     * Add user to group for company
     */
    addGroupUserRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.companyCodeOrSid === null || requestParameters.companyCodeOrSid === undefined) {
                throw new runtime.RequiredError('companyCodeOrSid', 'Required parameter requestParameters.companyCodeOrSid was null or undefined when calling addGroupUser.');
            }
            if (requestParameters.groupName === null || requestParameters.groupName === undefined) {
                throw new runtime.RequiredError('groupName', 'Required parameter requestParameters.groupName was null or undefined when calling addGroupUser.');
            }
            if (requestParameters.userId === null || requestParameters.userId === undefined) {
                throw new runtime.RequiredError('userId', 'Required parameter requestParameters.userId was null or undefined when calling addGroupUser.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
                headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
            }
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = typeof token === 'function' ? token("bearer-auth", []) : token;
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/v1/companies/{company_code_or_sid}/groups/{group_name}/users/{user_id}`.replace(`{${"company_code_or_sid"}}`, encodeURIComponent(String(requestParameters.companyCodeOrSid))).replace(`{${"group_name"}}`, encodeURIComponent(String(requestParameters.groupName))).replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters.userId))),
                method: 'PUT',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     * Add a user to a group for a specific company.
     * Add user to group for company
     */
    addGroupUser(companyCodeOrSid, groupName, userId) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.addGroupUserRaw({ companyCodeOrSid: companyCodeOrSid, groupName: groupName, userId: userId });
        });
    }
    /**
     * Cancel a group reservation for a specific company and group
     * Cancel group reservation
     */
    cancelGroupReservationRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.companyCodeOrSid === null || requestParameters.companyCodeOrSid === undefined) {
                throw new runtime.RequiredError('companyCodeOrSid', 'Required parameter requestParameters.companyCodeOrSid was null or undefined when calling cancelGroupReservation.');
            }
            if (requestParameters.groupName === null || requestParameters.groupName === undefined) {
                throw new runtime.RequiredError('groupName', 'Required parameter requestParameters.groupName was null or undefined when calling cancelGroupReservation.');
            }
            if (requestParameters.reservationSid === null || requestParameters.reservationSid === undefined) {
                throw new runtime.RequiredError('reservationSid', 'Required parameter requestParameters.reservationSid was null or undefined when calling cancelGroupReservation.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
                headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
            }
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = typeof token === 'function' ? token("bearer-auth", []) : token;
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/v1/companies/{company_code_or_sid}/groups/{group_name}/reservations/{reservation_sid}/cancel`.replace(`{${"company_code_or_sid"}}`, encodeURIComponent(String(requestParameters.companyCodeOrSid))).replace(`{${"group_name"}}`, encodeURIComponent(String(requestParameters.groupName))).replace(`{${"reservation_sid"}}`, encodeURIComponent(String(requestParameters.reservationSid))),
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     * Cancel a group reservation for a specific company and group
     * Cancel group reservation
     */
    cancelGroupReservation(companyCodeOrSid, groupName, reservationSid) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.cancelGroupReservationRaw({ companyCodeOrSid: companyCodeOrSid, groupName: groupName, reservationSid: reservationSid });
        });
    }
    /**
     */
    cancelQueuedGroupReservationsRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.companyCodeOrSid === null || requestParameters.companyCodeOrSid === undefined) {
                throw new runtime.RequiredError('companyCodeOrSid', 'Required parameter requestParameters.companyCodeOrSid was null or undefined when calling cancelQueuedGroupReservations.');
            }
            if (requestParameters.groupName === null || requestParameters.groupName === undefined) {
                throw new runtime.RequiredError('groupName', 'Required parameter requestParameters.groupName was null or undefined when calling cancelQueuedGroupReservations.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
                headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
            }
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = typeof token === 'function' ? token("bearer-auth", []) : token;
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/v1/companies/{company_code_or_sid}/groups/{group_name}/reservations/~cancel-all`.replace(`{${"company_code_or_sid"}}`, encodeURIComponent(String(requestParameters.companyCodeOrSid))).replace(`{${"group_name"}}`, encodeURIComponent(String(requestParameters.groupName))),
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     */
    cancelQueuedGroupReservations(companyCodeOrSid, groupName) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.cancelQueuedGroupReservationsRaw({ companyCodeOrSid: companyCodeOrSid, groupName: groupName });
        });
    }
    /**
     * Confirm a group reservation for a specific company and group
     * Confirm group reservation
     */
    confirmMatchedGroupReservationRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.companyCodeOrSid === null || requestParameters.companyCodeOrSid === undefined) {
                throw new runtime.RequiredError('companyCodeOrSid', 'Required parameter requestParameters.companyCodeOrSid was null or undefined when calling confirmMatchedGroupReservation.');
            }
            if (requestParameters.groupName === null || requestParameters.groupName === undefined) {
                throw new runtime.RequiredError('groupName', 'Required parameter requestParameters.groupName was null or undefined when calling confirmMatchedGroupReservation.');
            }
            if (requestParameters.reservationSid === null || requestParameters.reservationSid === undefined) {
                throw new runtime.RequiredError('reservationSid', 'Required parameter requestParameters.reservationSid was null or undefined when calling confirmMatchedGroupReservation.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
                headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
            }
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = typeof token === 'function' ? token("bearer-auth", []) : token;
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/v1/companies/{company_code_or_sid}/groups/{group_name}/reservations/{reservation_sid}/confirm`.replace(`{${"company_code_or_sid"}}`, encodeURIComponent(String(requestParameters.companyCodeOrSid))).replace(`{${"group_name"}}`, encodeURIComponent(String(requestParameters.groupName))).replace(`{${"reservation_sid"}}`, encodeURIComponent(String(requestParameters.reservationSid))),
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     * Confirm a group reservation for a specific company and group
     * Confirm group reservation
     */
    confirmMatchedGroupReservation(companyCodeOrSid, groupName, reservationSid) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.confirmMatchedGroupReservationRaw({ companyCodeOrSid: companyCodeOrSid, groupName: groupName, reservationSid: reservationSid });
        });
    }
    /**
     * Create a group for a specific company
     * Create group for company
     */
    createGroupRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.companyCodeOrSid === null || requestParameters.companyCodeOrSid === undefined) {
                throw new runtime.RequiredError('companyCodeOrSid', 'Required parameter requestParameters.companyCodeOrSid was null or undefined when calling createGroup.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
                headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
            }
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = typeof token === 'function' ? token("bearer-auth", []) : token;
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/v1/companies/{company_code_or_sid}/groups`.replace(`{${"company_code_or_sid"}}`, encodeURIComponent(String(requestParameters.companyCodeOrSid))),
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: (0, models_1.StreemApiCreateGroupRequestToJSON)(requestParameters.streemApiCreateGroupRequest),
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, models_1.StreemApiCreateGroupResponseFromJSON)(jsonValue));
        });
    }
    /**
     * Create a group for a specific company
     * Create group for company
     */
    createGroup(companyCodeOrSid, streemApiCreateGroupRequest) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.createGroupRaw({ companyCodeOrSid: companyCodeOrSid, streemApiCreateGroupRequest: streemApiCreateGroupRequest });
            return yield response.value();
        });
    }
    /**
     * Create a group reservation for a specific company and group
     * Create group reservation for company
     */
    createGroupReservationRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.companyCodeOrSid === null || requestParameters.companyCodeOrSid === undefined) {
                throw new runtime.RequiredError('companyCodeOrSid', 'Required parameter requestParameters.companyCodeOrSid was null or undefined when calling createGroupReservation.');
            }
            if (requestParameters.groupName === null || requestParameters.groupName === undefined) {
                throw new runtime.RequiredError('groupName', 'Required parameter requestParameters.groupName was null or undefined when calling createGroupReservation.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
                headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
            }
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = typeof token === 'function' ? token("bearer-auth", []) : token;
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/v1/companies/{company_code_or_sid}/groups/{group_name}/reservations`.replace(`{${"company_code_or_sid"}}`, encodeURIComponent(String(requestParameters.companyCodeOrSid))).replace(`{${"group_name"}}`, encodeURIComponent(String(requestParameters.groupName))),
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: (0, models_1.StreemApiCreateGroupReservationRequestToJSON)(requestParameters.streemApiCreateGroupReservationRequest),
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, models_1.StreemApiCreateGroupReservationResponseFromJSON)(jsonValue));
        });
    }
    /**
     * Create a group reservation for a specific company and group
     * Create group reservation for company
     */
    createGroupReservation(companyCodeOrSid, groupName, streemApiCreateGroupReservationRequest) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.createGroupReservationRaw({ companyCodeOrSid: companyCodeOrSid, groupName: groupName, streemApiCreateGroupReservationRequest: streemApiCreateGroupReservationRequest });
            return yield response.value();
        });
    }
    /**
     * Delete a group from a company
     * Delete group from company
     */
    deleteGroupRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.companyCodeOrSid === null || requestParameters.companyCodeOrSid === undefined) {
                throw new runtime.RequiredError('companyCodeOrSid', 'Required parameter requestParameters.companyCodeOrSid was null or undefined when calling deleteGroup.');
            }
            if (requestParameters.groupName === null || requestParameters.groupName === undefined) {
                throw new runtime.RequiredError('groupName', 'Required parameter requestParameters.groupName was null or undefined when calling deleteGroup.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
                headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
            }
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = typeof token === 'function' ? token("bearer-auth", []) : token;
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/v1/companies/{company_code_or_sid}/groups/{group_name}`.replace(`{${"company_code_or_sid"}}`, encodeURIComponent(String(requestParameters.companyCodeOrSid))).replace(`{${"group_name"}}`, encodeURIComponent(String(requestParameters.groupName))),
                method: 'DELETE',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     * Delete a group from a company
     * Delete group from company
     */
    deleteGroup(companyCodeOrSid, groupName) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.deleteGroupRaw({ companyCodeOrSid: companyCodeOrSid, groupName: groupName });
        });
    }
    /**
     * Remove a user from a group for a specific company.
     * Remove user from group for company
     */
    deleteGroupUserRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.companyCodeOrSid === null || requestParameters.companyCodeOrSid === undefined) {
                throw new runtime.RequiredError('companyCodeOrSid', 'Required parameter requestParameters.companyCodeOrSid was null or undefined when calling deleteGroupUser.');
            }
            if (requestParameters.groupName === null || requestParameters.groupName === undefined) {
                throw new runtime.RequiredError('groupName', 'Required parameter requestParameters.groupName was null or undefined when calling deleteGroupUser.');
            }
            if (requestParameters.userId === null || requestParameters.userId === undefined) {
                throw new runtime.RequiredError('userId', 'Required parameter requestParameters.userId was null or undefined when calling deleteGroupUser.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
                headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
            }
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = typeof token === 'function' ? token("bearer-auth", []) : token;
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/v1/companies/{company_code_or_sid}/groups/{group_name}/users/{user_id}`.replace(`{${"company_code_or_sid"}}`, encodeURIComponent(String(requestParameters.companyCodeOrSid))).replace(`{${"group_name"}}`, encodeURIComponent(String(requestParameters.groupName))).replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters.userId))),
                method: 'DELETE',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     * Remove a user from a group for a specific company.
     * Remove user from group for company
     */
    deleteGroupUser(companyCodeOrSid, groupName, userId) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.deleteGroupUserRaw({ companyCodeOrSid: companyCodeOrSid, groupName: groupName, userId: userId });
        });
    }
    /**
     * Get a group for a company by its name
     * Get group for company
     */
    getGroupRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.companyCodeOrSid === null || requestParameters.companyCodeOrSid === undefined) {
                throw new runtime.RequiredError('companyCodeOrSid', 'Required parameter requestParameters.companyCodeOrSid was null or undefined when calling getGroup.');
            }
            if (requestParameters.groupName === null || requestParameters.groupName === undefined) {
                throw new runtime.RequiredError('groupName', 'Required parameter requestParameters.groupName was null or undefined when calling getGroup.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
                headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
            }
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = typeof token === 'function' ? token("bearer-auth", []) : token;
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/v1/companies/{company_code_or_sid}/groups/{group_name}`.replace(`{${"company_code_or_sid"}}`, encodeURIComponent(String(requestParameters.companyCodeOrSid))).replace(`{${"group_name"}}`, encodeURIComponent(String(requestParameters.groupName))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, models_1.StreemApiGetGroupResponseFromJSON)(jsonValue));
        });
    }
    /**
     * Get a group for a company by its name
     * Get group for company
     */
    getGroup(companyCodeOrSid, groupName) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getGroupRaw({ companyCodeOrSid: companyCodeOrSid, groupName: groupName });
            return yield response.value();
        });
    }
    /**
     * Get a specified group reservation
     * Get Group Reservation
     */
    getGroupReservationRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.companyCodeOrSid === null || requestParameters.companyCodeOrSid === undefined) {
                throw new runtime.RequiredError('companyCodeOrSid', 'Required parameter requestParameters.companyCodeOrSid was null or undefined when calling getGroupReservation.');
            }
            if (requestParameters.groupName === null || requestParameters.groupName === undefined) {
                throw new runtime.RequiredError('groupName', 'Required parameter requestParameters.groupName was null or undefined when calling getGroupReservation.');
            }
            if (requestParameters.reservationSid === null || requestParameters.reservationSid === undefined) {
                throw new runtime.RequiredError('reservationSid', 'Required parameter requestParameters.reservationSid was null or undefined when calling getGroupReservation.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
                headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
            }
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = typeof token === 'function' ? token("bearer-auth", []) : token;
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/v1/companies/{company_code_or_sid}/groups/{group_name}/reservations/{reservation_sid}`.replace(`{${"company_code_or_sid"}}`, encodeURIComponent(String(requestParameters.companyCodeOrSid))).replace(`{${"group_name"}}`, encodeURIComponent(String(requestParameters.groupName))).replace(`{${"reservation_sid"}}`, encodeURIComponent(String(requestParameters.reservationSid))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, models_1.StreemApiGetGroupReservationResponseFromJSON)(jsonValue));
        });
    }
    /**
     * Get a specified group reservation
     * Get Group Reservation
     */
    getGroupReservation(companyCodeOrSid, groupName, reservationSid) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getGroupReservationRaw({ companyCodeOrSid: companyCodeOrSid, groupName: groupName, reservationSid: reservationSid });
            return yield response.value();
        });
    }
    /**
     * Get group reservation wait time for a specific group
     * Get group reservation wait time
     */
    getGroupReservationWaitTimeRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.companyCodeOrSid === null || requestParameters.companyCodeOrSid === undefined) {
                throw new runtime.RequiredError('companyCodeOrSid', 'Required parameter requestParameters.companyCodeOrSid was null or undefined when calling getGroupReservationWaitTime.');
            }
            if (requestParameters.groupName === null || requestParameters.groupName === undefined) {
                throw new runtime.RequiredError('groupName', 'Required parameter requestParameters.groupName was null or undefined when calling getGroupReservationWaitTime.');
            }
            if (requestParameters.priority === null || requestParameters.priority === undefined) {
                throw new runtime.RequiredError('priority', 'Required parameter requestParameters.priority was null or undefined when calling getGroupReservationWaitTime.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
                headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
            }
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = typeof token === 'function' ? token("bearer-auth", []) : token;
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/v1/companies/{company_code_or_sid}/groups/{group_name}/reservations/{priority}/wait_time`.replace(`{${"company_code_or_sid"}}`, encodeURIComponent(String(requestParameters.companyCodeOrSid))).replace(`{${"group_name"}}`, encodeURIComponent(String(requestParameters.groupName))).replace(`{${"priority"}}`, encodeURIComponent(String(requestParameters.priority))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, models_1.StreemApiGetGroupReservationWaitTimeResponseFromJSON)(jsonValue));
        });
    }
    /**
     * Get group reservation wait time for a specific group
     * Get group reservation wait time
     */
    getGroupReservationWaitTime(companyCodeOrSid, groupName, priority) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getGroupReservationWaitTimeRaw({ companyCodeOrSid: companyCodeOrSid, groupName: groupName, priority: priority });
            return yield response.value();
        });
    }
    /**
     * List the users in the group that have a certain availability status
     * List Group Availability
     */
    listGroupAvailabilityRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.companyCodeOrSid === null || requestParameters.companyCodeOrSid === undefined) {
                throw new runtime.RequiredError('companyCodeOrSid', 'Required parameter requestParameters.companyCodeOrSid was null or undefined when calling listGroupAvailability.');
            }
            if (requestParameters.groupName === null || requestParameters.groupName === undefined) {
                throw new runtime.RequiredError('groupName', 'Required parameter requestParameters.groupName was null or undefined when calling listGroupAvailability.');
            }
            const queryParameters = {};
            if (requestParameters.status !== undefined) {
                queryParameters['status'] = requestParameters.status;
            }
            if (requestParameters.pageSize !== undefined) {
                queryParameters['page_size'] = requestParameters.pageSize;
            }
            if (requestParameters.pageToken !== undefined) {
                queryParameters['page_token'] = requestParameters.pageToken;
            }
            const headerParameters = {};
            if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
                headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
            }
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = typeof token === 'function' ? token("bearer-auth", []) : token;
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/v1/companies/{company_code_or_sid}/groups/{group_name}/availability`.replace(`{${"company_code_or_sid"}}`, encodeURIComponent(String(requestParameters.companyCodeOrSid))).replace(`{${"group_name"}}`, encodeURIComponent(String(requestParameters.groupName))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, models_1.StreemApiListGroupAvailabilityRequestFromJSON)(jsonValue));
        });
    }
    /**
     * List the users in the group that have a certain availability status
     * List Group Availability
     */
    listGroupAvailability(companyCodeOrSid, groupName, status, pageSize, pageToken) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.listGroupAvailabilityRaw({ companyCodeOrSid: companyCodeOrSid, groupName: groupName, status: status, pageSize: pageSize, pageToken: pageToken });
            return yield response.value();
        });
    }
    /**
     * List the users that belong to a group.
     * List users in group
     */
    listGroupUsersRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.companyCodeOrSid === null || requestParameters.companyCodeOrSid === undefined) {
                throw new runtime.RequiredError('companyCodeOrSid', 'Required parameter requestParameters.companyCodeOrSid was null or undefined when calling listGroupUsers.');
            }
            if (requestParameters.groupName === null || requestParameters.groupName === undefined) {
                throw new runtime.RequiredError('groupName', 'Required parameter requestParameters.groupName was null or undefined when calling listGroupUsers.');
            }
            const queryParameters = {};
            if (requestParameters.pageSize !== undefined) {
                queryParameters['page_size'] = requestParameters.pageSize;
            }
            if (requestParameters.pageToken !== undefined) {
                queryParameters['page_token'] = requestParameters.pageToken;
            }
            const headerParameters = {};
            if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
                headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
            }
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = typeof token === 'function' ? token("bearer-auth", []) : token;
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/v1/companies/{company_code_or_sid}/groups/{group_name}/users`.replace(`{${"company_code_or_sid"}}`, encodeURIComponent(String(requestParameters.companyCodeOrSid))).replace(`{${"group_name"}}`, encodeURIComponent(String(requestParameters.groupName))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, models_1.StreemApiListGroupUsersResponseFromJSON)(jsonValue));
        });
    }
    /**
     * List the users that belong to a group.
     * List users in group
     */
    listGroupUsers(companyCodeOrSid, groupName, pageSize, pageToken) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.listGroupUsersRaw({ companyCodeOrSid: companyCodeOrSid, groupName: groupName, pageSize: pageSize, pageToken: pageToken });
            return yield response.value();
        });
    }
    /**
     * List the groups associated with the company
     * List groups for company
     */
    listGroupsRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.companyCodeOrSid === null || requestParameters.companyCodeOrSid === undefined) {
                throw new runtime.RequiredError('companyCodeOrSid', 'Required parameter requestParameters.companyCodeOrSid was null or undefined when calling listGroups.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
                headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
            }
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = typeof token === 'function' ? token("bearer-auth", []) : token;
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/v1/companies/{company_code_or_sid}/groups`.replace(`{${"company_code_or_sid"}}`, encodeURIComponent(String(requestParameters.companyCodeOrSid))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, models_1.StreemApiListGroupsResponseFromJSON)(jsonValue));
        });
    }
    /**
     * List the groups associated with the company
     * List groups for company
     */
    listGroups(companyCodeOrSid) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.listGroupsRaw({ companyCodeOrSid: companyCodeOrSid });
            return yield response.value();
        });
    }
    /**
     * List the groups that a user belongs to.
     * List user\'s groups
     */
    listUserGroupsRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.companyCodeOrSid === null || requestParameters.companyCodeOrSid === undefined) {
                throw new runtime.RequiredError('companyCodeOrSid', 'Required parameter requestParameters.companyCodeOrSid was null or undefined when calling listUserGroups.');
            }
            if (requestParameters.userId === null || requestParameters.userId === undefined) {
                throw new runtime.RequiredError('userId', 'Required parameter requestParameters.userId was null or undefined when calling listUserGroups.');
            }
            const queryParameters = {};
            if (requestParameters.pageSize !== undefined) {
                queryParameters['page_size'] = requestParameters.pageSize;
            }
            if (requestParameters.pageToken !== undefined) {
                queryParameters['page_token'] = requestParameters.pageToken;
            }
            const headerParameters = {};
            if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
                headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
            }
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = typeof token === 'function' ? token("bearer-auth", []) : token;
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/v1/companies/{company_code_or_sid}/groups/users/{user_id}`.replace(`{${"company_code_or_sid"}}`, encodeURIComponent(String(requestParameters.companyCodeOrSid))).replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters.userId))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, models_1.StreemApiListUserGroupsResponseFromJSON)(jsonValue));
        });
    }
    /**
     * List the groups that a user belongs to.
     * List user\'s groups
     */
    listUserGroups(companyCodeOrSid, userId, pageSize, pageToken) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.listUserGroupsRaw({ companyCodeOrSid: companyCodeOrSid, userId: userId, pageSize: pageSize, pageToken: pageToken });
            return yield response.value();
        });
    }
    /**
     */
    saveGroupReservationWaitMetricRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.companyCodeOrSid === null || requestParameters.companyCodeOrSid === undefined) {
                throw new runtime.RequiredError('companyCodeOrSid', 'Required parameter requestParameters.companyCodeOrSid was null or undefined when calling saveGroupReservationWaitMetric.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
                headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
            }
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = typeof token === 'function' ? token("bearer-auth", []) : token;
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/v1/companies/{company_code_or_sid}/groups/reservation-metrics`.replace(`{${"company_code_or_sid"}}`, encodeURIComponent(String(requestParameters.companyCodeOrSid))),
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: (0, models_1.StreemInternalApiSaveGroupAverageCallLengthRequestToJSON)(requestParameters.streemInternalApiSaveGroupAverageCallLengthRequest),
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, models_1.StreemInternalApiSaveGroupAverageCallLengthResponseFromJSON)(jsonValue));
        });
    }
    /**
     */
    saveGroupReservationWaitMetric(companyCodeOrSid, streemInternalApiSaveGroupAverageCallLengthRequest) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.saveGroupReservationWaitMetricRaw({ companyCodeOrSid: companyCodeOrSid, streemInternalApiSaveGroupAverageCallLengthRequest: streemInternalApiSaveGroupAverageCallLengthRequest });
            return yield response.value();
        });
    }
}
exports.GroupsApi = GroupsApi;
/**
    * @export
    * @enum {string}
    */
var ListGroupAvailabilityStatus;
(function (ListGroupAvailabilityStatus) {
    ListGroupAvailabilityStatus["AVAILABLE"] = "AVAILABILITY_STATUS_AVAILABLE";
    ListGroupAvailabilityStatus["NOTAVAILABLE"] = "AVAILABILITY_STATUS_NOT_AVAILABLE";
    ListGroupAvailabilityStatus["RESERVED"] = "AVAILABILITY_STATUS_RESERVED";
    ListGroupAvailabilityStatus["INCALL"] = "AVAILABILITY_STATUS_IN_CALL";
    ListGroupAvailabilityStatus["CONFIRMING"] = "AVAILABILITY_STATUS_CONFIRMING";
    ListGroupAvailabilityStatus["OFFLINE"] = "AVAILABILITY_STATUS_OFFLINE";
    ListGroupAvailabilityStatus["INVALID"] = "AVAILABILITY_STATUS_INVALID";
})(ListGroupAvailabilityStatus = exports.ListGroupAvailabilityStatus || (exports.ListGroupAvailabilityStatus = {}));
//# sourceMappingURL=GroupsApi.js.map